import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import DataTestIDHelper from "../../../../../../Helper/DataTestID/DataTestIDHelper";
import { AbsenceSalarieDto } from "../../../../../../dto/GenApi.iNotPaie.Dto/AbsenceSalarieDto";
import { ActionAbsencesEnum } from "../../../../../../dto/GenApi.iNotPaie.Dto/ActionAbsencesEnum";
import { EtatAbsencesEnum } from "../../../../../../dto/GenApi.iNotPaie.Dto/EtatAbsencesEnum";
import { ParametresInstance } from "../../../../../Controls/Parameters";

@Component
export default class TableauDemande extends Vue {
	@Prop()
	public absencesDemande: AbsenceSalarieDto[] = [];

	public demanderAnnulationAbsenceSalarie(absence: AbsenceSalarieDto): void {
		this.$emit("demanderAnnulationAbsence", absence);
	}

	public getLibelleEtat(absence: AbsenceSalarieDto): string {
		let libelleEtat = ParametresInstance.getLibelleEtatAbsence(absence.Etat);

		return libelleEtat[0].toUpperCase() + libelleEtat.slice(1);
	}

	public getAbsenceRequestEntryDataTestID(absence: AbsenceSalarieDto, suffix: string): string {
		return DataTestIDHelper.getAbsenceRequestDataTestID(absence.LibelleTypeAbsence, absence.DateDebut, absence.DateFin, "salarie-requestsList-", suffix);
	}
}



// WEBPACK FOOTER //
// ./src/components/gestionDesAbsences/listeDesDemandes/espaceSalarie/tableaux/tableauDemande/tableauDemande.ts